"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLTableHeader = void 0;
const findGroupByKey_1 = __importDefault(require("@opsbase/lib-data-query/helpers/findGroupByKey"));
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const ChartingPalette_1 = __importDefault(require("@opsbase/lib-palette/ChartingPalette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useViewActions_1 = __importDefault(require("@opsbase/web-ctrl-view/useViewActions"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const react_1 = __importStar(require("react"));
const react_sortablejs_1 = require("react-sortablejs");
const DVLTableRowHeader_1 = __importDefault(require("../DVLTableRow/DVLTableRowHeader"));
const DVLTableHeaderCell_1 = __importDefault(require("./DVLTableHeaderCell"));
const makeMyClasses = () => ({
    root: {
        width: 'fit-content',
        borderBottom: '1px solid ' + lib_palette_1.default.LineGrey.main,
        minWidth: '100%',
    },
    dragContainer: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        flex: '1 1 0%',
    },
    ghost: {
        backgroundColor: `${lib_palette_1.default.LightBlue.main} !important`,
    },
    drag: {
        opacity: 0.2,
    },
});
function makeDraggable(fields, isPinned) {
    return fields
        .map((f, i) => i === 0 || (isPinned && i === 1)
        ? undefined
        : {
            id: f.key,
            title: f.label,
            field: f,
        })
        .filter(f => !!f);
}
function DVLTableHeader() {
    const dt = (0, useDataTree_1.default)();
    const { fields, groupBys, maxVisibleFields, pinField } = (0, useView_1.default)(dt.viewId);
    const { moveField } = (0, useViewActions_1.default)(dt.viewId);
    const isPinned = !!pinField;
    const visibleFields = (0, react_1.useRef)(fields
        .filter(field => !field.hidden)
        .filter(field => !(0, findGroupByKey_1.default)(groupBys, field.key.toString()))
        .slice(0, maxVisibleFields));
    const [draggableFields, setDraggableFields] = (0, react_1.useState)(makeDraggable(visibleFields.current, isPinned));
    const [dragging, setDragging] = (0, react_1.useState)(false);
    const nodeKey = dt.rootNode.nodeKey;
    const customPalette = ChartingPalette_1.default.generatePalette(fields.filter(f => f.key === ViewFieldKey_1.default.QUESTIONANSWER).length);
    let paletteIdx = 0;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    (0, react_1.useEffect)(() => {
        visibleFields.current = fields
            .filter(field => !field.hidden)
            .filter(field => !(0, findGroupByKey_1.default)(groupBys, field.key.toString()))
            .slice(0, maxVisibleFields);
        setDraggableFields(makeDraggable(visibleFields.current, isPinned));
    }, [fields, groupBys, isPinned, maxVisibleFields]);
    const handleDragStart = (0, react_1.useCallback)(() => setDragging(true), []);
    const handleDragEnd = (0, react_1.useCallback)(e => {
        const oldIndex = fields.findIndex(f => f === visibleFields.current[e.oldIndex + 1]);
        const newIndex = fields.findIndex(f => f === visibleFields.current[e.newIndex + 1]);
        moveField(oldIndex, newIndex);
        setDragging(false);
    }, [fields, moveField]);
    const handleSetList = (0, react_1.useCallback)(v => setDraggableFields(v), []);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Horizontal_1.default, { classes: { root: myCss.root } },
        react_1.default.createElement(DVLTableRowHeader_1.default, { nodeKey: nodeKey },
            react_1.default.createElement(DVLTableHeaderCell_1.default, { field: fields[0] }),
            isPinned && react_1.default.createElement(DVLTableHeaderCell_1.default, { field: fields[1] })),
        react_1.default.createElement(react_sortablejs_1.ReactSortable, { className: myCss.dragContainer, animation: 100, direction: "horizontal", easing: "cubic-bezier(1, 0, 0, 1)", dragClass: myCss.drag, ghostClass: myCss.ghost, list: draggableFields, filter: ".notSortable", setList: handleSetList, onStart: handleDragStart, onEnd: handleDragEnd }, draggableFields.map((df, idx) => {
            let color;
            if (df.field.key === ViewFieldKey_1.default.QUESTIONANSWER) {
                color = customPalette[paletteIdx];
                paletteIdx++;
            }
            return (react_1.default.createElement(DVLTableHeaderCell_1.default, { key: 'header' + idx + 1, idx: idx + 1, field: df.field, disabled: dragging, color: color }));
        })))), [
        myCss,
        nodeKey,
        fields,
        isPinned,
        draggableFields,
        handleSetList,
        handleDragStart,
        handleDragEnd,
        dragging,
        customPalette,
        paletteIdx,
    ]);
}
exports.DVLTableHeader = DVLTableHeader;
exports.default = DVLTableHeader;
